const CHARACTER_CATEGORY_STORAGE_KEY = 'vcs_dashboard_character_categories';

/* date_of_change: 2026-04-06
   rule_reference: Dashboard vault + character editor category contract - heroes and NPCs must share one persisted category source so tab-aware creation and editor toggles stay in sync. */
export const resolveCharacterCategory = (category) => (String(category || '').trim().toLowerCase() === 'npc' ? 'npc' : 'hero');

export const readCharacterCategories = () => {
  if (typeof localStorage === 'undefined') {
    return {};
  }

  try {
    const stored = localStorage.getItem(CHARACTER_CATEGORY_STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_error) {
    return {};
  }
};

export const writeCharacterCategory = (characterId, category) => {
  if (!characterId || typeof localStorage === 'undefined') {
    return;
  }

  const nextCategories = readCharacterCategories();
  nextCategories[characterId] = resolveCharacterCategory(category);
  localStorage.setItem(CHARACTER_CATEGORY_STORAGE_KEY, JSON.stringify(nextCategories));
};

export const inferCharacterCategory = (entity, displayName) => {
  const categories = readCharacterCategories();
  const override = entity?.id ? categories[entity.id] : null;
  if (override === 'npc' || override === 'hero') {
    return override;
  }

  const tags = Array.isArray(entity?.tags) ? entity.tags.map((tag) => String(tag).toLowerCase()) : [];
  if (tags.includes('npc') || tags.includes('non-player') || tags.includes('nonplayer')) {
    return 'npc';
  }

  const normalizedName = String(displayName || '').toLowerCase();
  if (/(npc|guard|captain|bandit|innkeeper|merchant|villager|priest|noble|cultist|soldier)/.test(normalizedName)) {
    return 'npc';
  }

  return 'hero';
};

export const getNewVaultEditorRoute = (activeVaultTab) => {
  if (activeVaultTab === 'monsters') {
    return '/monster/edit/new';
  }

  const category = activeVaultTab === 'npcs' ? 'npc' : 'hero';
  return `/character/edit/new?category=${category}`;
};
